import { render, staticRenderFns } from "./InputData.vue?vue&type=template&id=e1e3d406"
import script from "./InputData.vue?vue&type=script&lang=ts"
export * from "./InputData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports